<template>
  <div class="sales-supervisor-index">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/salesSupervisor/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工作台</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="商户:">
        <el-input
          size="small"
          v-model="formInline.merchantName"
          placeholder="请输入商户名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="服务商:">
        <el-input
          size="small"
          v-model="formInline.disCompanyName"
          placeholder="请输入服务商名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="商户类型:">
        <el-select
          size="small"
          v-model="formInline.agentType"
          placeholder="全部"
          clearable
        >
          <el-option
            v-for="item in merchantTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="电销:">
        <el-select
          size="small"
          v-model="formInline.phoneSalesId"
          placeholder="请选择电销销售"
          clearable
        >
          <el-option
            v-for="item in salesOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="起始时间:">
        <el-date-picker
          size="small"
          v-model="formInline.dateRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button size="small" icon="el-icon-refresh-left" @click="handleReset">清空</el-button>
      </el-form-item>
    </el-form>

    <!-- 概览数据 -->
    <el-row :gutter="20" class="stat-row">
      <el-col :span="6">
        <el-card class="stat-card stat-card--primary" shadow="hover">
          <div class="stat-inner" v-loading="loading">
            <i class="el-icon-s-custom stat-icon"></i>
            <div class="stat-content">
              <div class="stat-value">{{ stats.teamMemberCount }}</div>
              <div class="stat-label">团队人数</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card stat-card--success" shadow="hover">
          <div class="stat-inner" v-loading="loading">
            <i class="el-icon-s-custom stat-icon"></i>
            <div class="stat-content">
              <div class="stat-value">{{ stats.customerCount }}</div>
              <div class="stat-label">客户数量</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card stat-card--warning stat-card--amount" shadow="hover">
          <div class="stat-inner" v-loading="loading">
            <i class="el-icon-s-finance stat-icon"></i>
            <div class="stat-content">
              <div class="stat-value">{{ formatAmount(stats.totalPreTaxAmount) }}</div>
              <div class="stat-label">流水（元）</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card stat-card--danger" shadow="hover">
          <div class="stat-inner" v-loading="loading">
            <i class="el-icon-s-data stat-icon"></i>
            <div class="stat-content">
              <div class="stat-value">{{ formatAmount(stats.totalGrossProfit) }}</div>
              <div class="stat-label">总毛利（元）</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 快捷入口 -->
    <div class="quick-entries">
      <span class="quick-entries-label">快捷入口：</span>
      <el-button
        type="text"
        icon="el-icon-s-custom"
        @click="jumpToPage('/salesSupervisor/teamList')"
      >
        销售列表
      </el-button>
      <el-button
        type="text"
        icon="el-icon-s-shop"
        @click="jumpToPage('/salesSupervisor/merchantList')"
      >
        客户列表
      </el-button>
      <el-button
        type="text"
        icon="el-icon-s-order"
        @click="jumpToPage('/salesSupervisor/salesBatchStatistics')"
      >
        批次统计
      </el-button>
      <el-button
        type="text"
        icon="el-icon-date"
        @click="jumpToPage('/salesSupervisor/monthlyFlow')"
      >
        月度流水
      </el-button>
      <el-button
        type="text"
        icon="el-icon-s-finance"
        @click="jumpToPage('/salesSupervisor/monthlyGrossProfit')"
      >
        月度毛利
      </el-button>
      <el-button
        type="text"
        icon="el-icon-s-data"
        @click="jumpToPage('/salesSupervisor/monthlySignCount')"
      >
        月度签约
      </el-button>
    </div>
  </div>
</template>

<script>
import { getSalesLeaderHomeStats, getTeamSalesList } from '../../api/userMG';

export default {
  name: 'SalesSupervisorIndex',
  data() {
    return {
      loading: false,
      formInline: {
        merchantName: '',
        disCompanyName: '',
        agentType: null,
        dateRange: [],
        startDate: '',
        endDate: '',
        phoneSalesId: null
      },
      merchantTypeList: [
        {
          label: '全部',
          value: null
        },
        {
          label: '普通商户',
          value: 1
        },
        {
          label: '代理商户',
          value: 2
        }
      ],
      stats: {
        teamMemberCount: 0,
        customerCount: 0,
        totalPreTaxAmount: 0,
        totalManagementFee: 0,
        totalGrossProfit: 0
      },
      // 该团队下所有销售，用于电销/面销下拉
      salesOptions: []
    };
  },
  created() {
    this.fetchStats();
    this.fetchSalesOptions();
  },
  methods: {
    fetchStats() {
      this.loading = true;
      // 处理起止时间
      if (this.formInline.dateRange && this.formInline.dateRange.length === 2) {
        this.formInline.startDate = this.formInline.dateRange[0];
        this.formInline.endDate = this.formInline.dateRange[1];
      } else {
        this.formInline.startDate = '';
        this.formInline.endDate = '';
      }
      const params = {
        merchantName: this.formInline.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        agentType: this.formInline.agentType,
        startDate: this.formInline.startDate,
        endDate: this.formInline.endDate,
        phoneSalesId: this.formInline.phoneSalesId
      };
      getSalesLeaderHomeStats(params)
        .then((res) => {
          this.loading = false;
          if (res && (res.msg === 'success' || res.code === 0)) {
            const data = res.data || {};
            this.stats.teamMemberCount = data.teamMemberCount != null ? data.teamMemberCount : 0;
            this.stats.customerCount = data.customerCount != null ? data.customerCount : 0;
            this.stats.totalPreTaxAmount = data.totalPreTaxAmount != null ? data.totalPreTaxAmount : 0;
            this.stats.totalManagementFee = data.totalManagementFee != null ? data.totalManagementFee : 0;
            this.stats.totalGrossProfit = data.totalGrossProfit != null ? data.totalGrossProfit : 0;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 获取该团队下所有销售，用于电销/面销下拉
    fetchSalesOptions() {
      getTeamSalesList({ page: 1, pageSize: 9999, saleName: '' })
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0)) {
            const data = res.data || {};
            this.salesOptions = Array.isArray(data.items) ? data.items : [];
          } else {
            this.salesOptions = [];
          }
        })
        .catch(() => {
          this.salesOptions = [];
        });
    },
    handleSearch() {
      this.fetchStats();
    },
    handleReset() {
      this.formInline = {
        merchantName: '',
        disCompanyName: '',
        agentType: null,
        dateRange: [],
        startDate: '',
        endDate: '',
        phoneSalesId: null
      };
      this.fetchStats();
    },
    formatAmount(val) {
      if (val == null || val === '') {
        return '0.00';
      }
      const num = Number(val);
      if (isNaN(num)) {
        return '0.00';
      }
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    // 大数字用万/亿缩写，避免显示不全；悬停 title 显示完整金额
    formatAmountShort(val) {
      if (val == null || val === '') {
        return '0.00';
      }
      const num = Number(val);
      if (isNaN(num)) {
        return '0.00';
      }
      const abs = Math.abs(num);
      const sign = num < 0 ? '-' : '';
      if (abs >= 1e8) {
        return sign + (abs / 1e8).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '亿';
      }
      if (abs >= 1e4) {
        return sign + (abs / 1e4).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '万';
      }
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    jumpToPage(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style scoped>
.sales-supervisor-index {
  padding-bottom: 24px;
}
.user-search {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
.stat-row {
  margin-top: 0;
  margin-bottom: 20px;
}
.stat-card {
  border-radius: 8px;
}
.stat-card--primary .stat-icon {
  color: #409eff;
}
.stat-card--primary .stat-value {
  color: #409eff;
}
.stat-card--success .stat-icon {
  color: #67c23a;
}
.stat-card--success .stat-value {
  color: #67c23a;
}
.stat-card--warning .stat-icon {
  color: #e6a23c;
}
.stat-card--warning .stat-value {
  color: #e6a23c;
}
.stat-card--danger .stat-icon {
  color: #f56c6c;
}
.stat-card--danger .stat-value {
  color: #f56c6c;
}
.stat-inner {
  display: flex;
  align-items: center;
  padding: 8px 0;
}
.stat-card--amount .stat-inner {
  align-items: flex-start;
}
.stat-icon {
  font-size: 40px;
  margin-right: 16px;
}
.stat-content {
  flex: 1;
  min-width: 0;
}
.stat-value {
  font-size: 28px;
  font-weight: 600;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.stat-amount-row {
  display: flex;
  justify-content: space-between;
}
.stat-amount-item {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
.stat-amount-item + .stat-amount-item {
  margin-left: 24px;
}
.stat-value--secondary {
  font-size: 22px;
}
.stat-value-row + .stat-value-row {
  margin-top: 8px;
}
.stat-label {
  font-size: 14px;
  color: #909399;
  margin-top: 4px;
}
.quick-entries {
  padding: 16px;
  background: #fff;
  border-radius: 8px;
}
.quick-entries-label {
  margin-right: 12px;
  color: #606266;
  font-size: 14px;
}
.quick-entries .el-button {
  padding: 0 8px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/salesSupervisor/index.vue